export enum ConfigKeys {
  DO_KDY_MUZE_ASISTENT_ZMENIT_NABIZENY_CAS = 'assistant_availability_change_by_assistant_limit_minutes_to_next_monday',
  DO_KDY_MUSI_ASISTENT_POTVRDIT_ASISTENCI = 'confirmation_of_next_week_assistances_by_assistant_limit_minutes_to_next_monday',
  ODKDY_JE_POZDE_OBJEDNANA_ASISTENCE_HODINY = 'late_order_assistance_limit_minutes_to_next_monday',
  POZDE_OBJEDNANA_JESTLI_SE_VZTAHUJE_NA_KOORDINATORY = 'late_order_assistance_limit_applies_to_coordinators',
  ODKDY_JE_POZDE_ZRUSENA_JIZ_POTVRZENA_ASISTENCE_HODINY = 'late_canceled_confirmed_assistance_limit_minutes_to_assistance',
  DOKDY_JE_MOZNA_EDITACE_PROBEHLYCH_ASISTENCI_DNY = 'editing_past_assistance_by_coordinator_days',
  ORDINACNI_HODINY_START_NO_TZ = 'working_hhmm_start_no_timezone',
  ORDINACNI_HODINY_END_NO_TZ = 'working_hhmm_end_no_timezone',
  STORNO_BEZ_LIMITU_O_VIKENDECH_A_SVATCICH = 'late_canceled_assistance_no_limit_on_weekend_and_holidays',
  VYCHOZI_DOBA_PREJEZDU_MINUTY = 'default_transit_duration_minutes',

  ORGANIZACE_NAZEV = 'organization_name',
  ORGANIZACE_LOGO = 'organization_logo',
  ORGANIZACE_ADRESA_SIDLA = 'organization_address',
  ORGANIZACE_ICO = 'organization_id_number',
  ORGANIZACE_CISLO_UCTU = 'organization_account_number',
  ORGANIZACE_BANKA = 'organization_bank',
  ORGANIZACE_TELEFON = 'organization_phone',

  TOGGLEABLE_MODULES = 'active_modules',
  ASSISTANT_LIST_CUSTOM_COLUMNS = 'assistant_list_custom_columns',

  JOURNAL_ENTRY_HISTORY_ENABLED = 'journal_entry_history_enabled',

  DEPRECATED_KONTAKTY = 'contact_information',

  CLIENT_CANCEL_FEE_MODE = 'client_cancel_fee_mode',
}
